import React from 'react'
import { useNavigate } from 'react-router-dom'
import cfg from '../config/billing'
import './Pricing.css'

const tiers = [
  { key: 'free',        name: 'Free',        price: '$0',   priceId: cfg.priceFree,       bullets: ['200k tokens/mo','30-day retention','Built-in redaction'], popular: false },
  { key: 'pro',         name: 'Pro',         price: '$199', priceId: cfg.pricePro,        bullets: ['2M tokens/mo','180-day retention','Custom redaction + reports'], popular: true },
  { key: 'enterprise',  name: 'Enterprise',  price: '$499', priceId: cfg.priceEnterprise, bullets: ['10M tokens/mo','365-day retention','All packs + S3/Webhooks'], popular: false },
]

export default function Pricing() {
  const nav = useNavigate()
  const selectPlan = (t) => {
    const plan = { tier: t.key, priceId: t.priceId }
    localStorage.setItem('selectedPlan', JSON.stringify(plan))
    nav(`/signup-choice?plan=${encodeURIComponent(t.key)}`) // no API calls; org-first next
  }
  return (
    <div className="pricing-wrap">
      <h1 className="pricing-h">Choose your plan</h1>
      <div className="pricing-grid">
        {tiers.map(t => (
          <div key={t.key} className={`pricing-card ${t.key}${t.popular ? ' popular' : ''}`}>
            {t.popular && <span className="popular-badge">Most Popular</span>}
            <div className="card-h">{t.name}</div>
            <div className="card-price">{t.price}<span className="per">/mo</span></div>
            <ul className="card-list">{t.bullets.map(b => <li key={b}>{b}</li>)}</ul>
            <button className="card-btn" onClick={() => selectPlan(t)}>Select {t.name}</button>
          </div>
        ))}
      </div>
      <div className="pricing-foot">
        <span>Already have an account?</span>
        <button className="link-btn" onClick={() => nav('/sign-in')}>Log in</button>
      </div>
    </div>
  )
}
